'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * Attention, le tlLiveForm ne surveille que les interactions directes utilisateur, mais pas les changements fait sur le model
 */
ngModule.directive("tlLiveForm", function ($parse, $timeout) {
  return {
    restrict: "A",
    controller: function controller($scope) {
      var ctrl = this,
        handler = null;
      ctrl.setHandler = function (_handler) {
        handler = _handler;
      };
      ctrl.notifyFieldChange = function () {
        handler && handler();
      };
    },
    link: function link($scope, $el, $attrs, ctrl) {
      if ($attrs.tlLiveForm) {
        var formHandler = $parse($attrs.tlLiveForm);
        var executeHandler = function executeHandler() {
          return formHandler($scope);
        };
        ctrl.setHandler(executeHandler);
      }
      var bindDelegateEvents = function bindDelegateEvents() {
        var prevFocusInputValue = null;
        var onInputFocus = function onInputFocus(event) {
          var input = $(event.currentTarget);
          prevFocusInputValue = input.val();
        };
        var onInputBlur = function onInputBlur(event) {
          var input = $(event.currentTarget);
          var inputValue = input.val();
          if (inputValue !== prevFocusInputValue) {
            $scope.$apply(function () {
              ctrl.notifyFieldChange();
            });
            prevFocusInputValue = inputValue;
          }
        };
        var onInputKeypress = function onInputKeypress(event) {
          if (event.which === 13) {
            var input = $(event.currentTarget);
            prevFocusInputValue = input.val();
            $scope.$apply(function () {
              ctrl.notifyFieldChange();
            });
          }
        };
        var onSelectChange = function onSelectChange(event) {
          // seems not to work when el is select without the defer...
          $timeout(function () {
            ctrl.notifyFieldChange();
          }, 0);
        };
        $el.delegate("input:not([type=radio], [type=checkbox])", "focusin", onInputFocus);
        $el.delegate("input:not([type=radio], [type=checkbox])", "focusout", onInputBlur);
        $el.delegate("input:not([type=radio], [type=checkbox])", "keypress", onInputKeypress);
        $el.delegate(".tl-select, .tl-checkbox, select, input[type=checkbox], input[type=radio]", "change", onSelectChange);
      };
      bindDelegateEvents();
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/form/liveForm.js
// module id = 2949
// module chunks = 13